import { useAuthCheck } from "@hooks/api/useAuthCheck";
import { useAsyncEffect } from "use-async-effect";
import { useAuthStatusStore } from "@stepHooks/useAuthStatusStore";

// TODO [LOWA-30534] From https://tiny.amazon.com/yu0qkk8y
export const useCheckUserAuthentication = () => {
    const authStatus = useAuthStatusStore((store) => store.authStatus);
    const onSignIn = useAuthStatusStore((store) => store.onSignIn);
    const onUnauthenticated = useAuthStatusStore(
        (store) => store.onUnauthenticated
    );

    // Check User Status
    const {
        authCheckResponseId,
        userInfo,
        isCheckingAuth,
        isAuthCheckError,
    } = useAuthCheck();
    useAsyncEffect(async () => {
        if (isCheckingAuth) {
            return;
        }
        if (isAuthCheckError) {
            onUnauthenticated();
            return;
        }

        // Success
        window.userName = userInfo.username;
        window.userSub = userInfo.userId;
        onSignIn(userInfo.username, userInfo.userId);
    }, [authCheckResponseId, isCheckingAuth, isAuthCheckError]);

    return authStatus;
};
